import { type InvestmentAccountStatus } from '../investments/investments'

export enum Month {
  JANUARY = 'JANUARY',
  FEBRUARY = 'FEBRUARY',
  MARCH = 'MARCH',
  APRIL = 'APRIL',
  MAY = 'MAY',
  JUNE = 'JUNE',
  JULY = 'JULY',
  AUGUST = 'AUGUST',
  SEPTEMBER = 'SEPTEMBER',
  OCTOBER = 'OCTOBER',
  NOVEMBER = 'NOVEMBER',
  DECEMBER = 'DECEMBER',
}

export const MONTH_ORDER = [
  Month.JANUARY,
  Month.FEBRUARY,
  Month.MARCH,
  Month.APRIL,
  Month.MAY,
  Month.JUNE,
  Month.JULY,
  Month.AUGUST,
  Month.SEPTEMBER,
  Month.OCTOBER,
  Month.NOVEMBER,
  Month.DECEMBER,
]

export interface DocumentCenterDates {
  year: string
  months: Month[]
}

export interface CustomerStatementsDatesOutput {
  statementsDates: DocumentCenterDates[]
}

export interface CustomerTaxDocumentsDates {
  years: string[]
}

export interface StatementsDates {
  year: string
  months: Month[]
}

export interface CustomerStatementsDates {
  statementsDates: StatementsDates[]
}

export interface CustomerTaxDocumentsYearsOutput {
  years: string[]
}

export interface CustomerLegalDocumentsOutput {
  documents: DocumentCenterDocument[]
}

export interface CustomerTaxDocumentsOutput {
  documents: DocumentCenterDocument[]
}

export interface CustomerLegalDocumentPartnersOutput {
  partners: LegalDocumentPartner[]
}

export interface CustomerLegalDocumentPartners {
  partners: LegalDocumentPartner[]
}

export enum LegalDocumentPartner {
  DRIVEWEALTH = 'DRIVEWEALTH',
  EVERGREEN_WEALTH = 'EVERGREEN_WEALTH',
  EVERGREEN_WEALTH_ADVISORS = 'EVERGREEN_WEALTH_ADVISORS',
}

export interface DocumentCenterDocument {
  name: string
  url: string
  rank: number
}

export interface CustomerStatementsOutput {
  statements: DocumentCenterDocument[]
}

export interface CustomerLegalDocuments {
  documents: DocumentCenterDocument[]
}

export interface CustomerLegalDocumentsInput {
  partnerName: LegalDocumentPartner
}

export interface CustomerStatementsInput {
  month: Month
  year: string
}

export interface CustomerStatements {
  statements: DocumentCenterDocument[]
}

export interface CustomerTaxDocumentsInput {
  year: string
}

export interface CustomerTaxDocuments {
  documents: DocumentCenterDocument[]
}

export interface InvestmentTradeConfirmLinkInput {
  fileKey: string
  alias: number
}

export interface InvestmentDocumentLink {
  url: string
}

export interface InvestmentTradeConfirmLinkOutput {
  confirm: InvestmentDocumentLink
}

export interface InvestmentTradeConfirmAccount {
  alias: number
  status: InvestmentAccountStatus
  accountName: string
  __typename?: string
}

export interface InvestmentTradeConfirmAccountsOutput {
  accounts: InvestmentTradeConfirmAccount[]
}
